const GetBrowser = require('./GetBrowser');

function _testUserAgent_(map) {
    let obj;
    let s = 'default';
    let name;
    for (name in map) {
        if (!map.hasOwnProperty(name)) continue;
        obj = map[name];
        if (obj.regExp.test(navigator.userAgent) || typeof obj.browsersRegExp !== 'undefined' && obj.browsersRegExp.test(GetBrowser()))
            s = name;
    }
    return s;
}

module.exports = _testUserAgent_;


// WEBPACK FOOTER //
// ./js/viscom/viscomjs/utils/TestUserAgent.js